import PerksCard from './PerksCard';

export default PerksCard;
